import { render, staticRenderFns } from "./blog-like-comment.vue?vue&type=template&id=5a6c7214&"
import script from "./blog-like-comment.vue?vue&type=script&lang=js&"
export * from "./blog-like-comment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports